import { useEffect, useState } from 'react';
import { Table } from 'antd';
import { isMobile } from '../../../../../../services/clientService';
import { getTableColumns } from './constants';
import { postRequest } from '../../../../../../services/requestService';
import { showErrorToast } from '../../../../../../services/notificationsService';

export const OpportunitiesTable = ({ dispatch }) => {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const fetchMissedOpportunities = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        '/buyers/opportunities/get-missed-opportunities',
      );
      setDataSource(response.data.items || []);
    } catch (error) {
      showErrorToast('Failed to fetch missed opportunities');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMissedOpportunities();
  }, []);

  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  const pagination = {
    position: ['bottomRight'],
    defaultPageSize: 100,
  };

  return (
    <Table
      rowKey="address"
      loading={loading}
      columns={getTableColumns(dispatch)}
      dataSource={dataSource}
      scroll={tableScroll}
      pagination={pagination}
    />
  );
};
